// extracted by mini-css-extract-plugin
module.exports = {"container":"PageContent_container__vJVOx"};